'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef, useState } from 'react';
import { Icon } from '../system/icons';
import { I } from '../system/icons';
import { CONTROL_HEIGHT } from '../system/sizing';
import { useUiStrings } from '../client/i18n/UiStrings/UiStrings';
import styles from './SearchInput.module.css';
export const SearchInput = forwardRef(function SearchInput({ placeholder, size = 'md', trailing, fluid, clearAriaLabel, style, ...rest }, ref) {
    const strings = useUiStrings();
    const h = CONTROL_HEIGHT[size];
    const iconSize = size === 'sm' ? 14 : size === 'lg' ? 18 : 16;
    // The clear button needs the node regardless of whether the caller took
    // the forwarded ref.
    const innerRef = useRef(null);
    const setRefs = (node) => {
        innerRef.current = node;
        if (typeof ref === 'function')
            ref(node);
        else if (ref)
            ref.current = node;
    };
    // Show-clear state. Controlled callers are the source of truth via
    // `value`; uncontrolled ones are tracked from input events.
    const [uncontrolledHasText, setUncontrolledHasText] = useState(() => String(rest.defaultValue ?? '').length > 0);
    const hasText = rest.value !== undefined ? String(rest.value).length > 0 : uncontrolledHasText;
    const handleInput = (e) => {
        setUncontrolledHasText(e.currentTarget.value.length > 0);
        rest.onInput?.(e);
    };
    // Empty the field through the native value setter and a real bubbling
    // `input` event so React's synthetic onChange fires — controlled callers
    // observe the clear exactly as if the user had selected-all + deleted,
    // with no per-call-site wiring.
    const clear = () => {
        const input = innerRef.current;
        if (input === null)
            return;
        const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
        setter?.call(input, '');
        input.dispatchEvent(new Event('input', { bubbles: true }));
        setUncontrolledHasText(false);
        input.focus();
    };
    return (_jsxs("div", { "data-size": size, "data-fluid": fluid ? 'true' : undefined, className: styles.root, style: { height: h, ...style }, children: [_jsx("span", { className: styles.icon, children: _jsx(Icon, { size: iconSize, color: "var(--muted-foreground)", children: I.search }) }), _jsx("input", { placeholder: placeholder ?? strings.searchInputPlaceholder, "data-size": size, "data-trailing": trailing || hasText ? 'true' : undefined, ...rest, ref: setRefs, onInput: handleInput, className: [styles.input, rest.className].filter(Boolean).join(' ') }), hasText ? (_jsx("button", { type: "button", className: styles.clear, "aria-label": clearAriaLabel ?? strings.searchInputClear, onClick: clear, children: _jsx(Icon, { size: iconSize, color: "var(--muted-foreground)", children: I.x }) })) : trailing ? (_jsx("span", { className: styles.trailing, children: trailing })) : null] }));
});
//# sourceMappingURL=SearchInput.js.map